<div ngbDropdown #myDrop="ngbDropdown" class="d-inline-block select-status__dropdown">
  <button type="button" class="vox-btn vox-btn-secondary select-status__dropdown_btn" id="dropdownBasic2"
    data-toggle="dropdown" ngbDropdownToggle>{{'customers.filters.statuses.' + selectedStatus | translate}}</button>
  <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
    <button type="button" ngbDropdownItem class="select-status__dropdown_item" *ngFor="let status of statuses"
      (click)="onSelectStatus(status)">{{'customers.filters.statuses.' + status | translate}}</button>
  </div>
</div>